var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconBinoculars = function SvgIconBinoculars(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.16 3.503a3.26 3.26 0 0 0-2.292.942 1 1 0 0 0-.212.308l-3.895 8.852a4.7 4.7 0 0 0-.511 2.145 4.75 4.75 0 1 0 9.5-.062V9.625h2.5v6.125a4.75 4.75 0 1 0 8.986-2.15l-3.893-8.847a1 1 0 0 0-.212-.308 3.26 3.26 0 0 0-4.584 0 1 1 0 0 0-.297.711v2.469h-2.5V5.156a1 1 0 0 0-.297-.71 3.26 3.26 0 0 0-2.292-.943m10.79 7.592L16.6 5.76a1.26 1.26 0 0 0-1.351-.11v6.227a4.771 4.771 0 0 1 3.7-.782m1.484 3.373.156.356q.158.437.16.926a2.75 2.75 0 1 1-.316-1.282m-16.87.005-.153.346a2.75 2.75 0 1 0 5.338.955v-.071a2.75 2.75 0 0 0-5.185-1.23M6 11c1.025 0 1.974.325 2.75.876V5.65a1.26 1.26 0 0 0-1.352.11l-2.347 5.336Q5.51 11 6 11",
    clipRule: "evenodd"
  })));
};
export default SvgIconBinoculars;